import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

const SEAL_CLIP_PATH =
  "m335.5 64h64.5c26.5 0 48 21.49 48 48v64.5l45.6 45.6c18.7 18.7 18.7 49.1 0 67.8l-45.6 45.6v64.5c0 26.5-21.5 48-48 48h-64.5l-45.6 45.6c-18.7 18.7-49.1 18.7-67.8 0l-45.6-45.6h-64.5c-26.51 0-48-21.5-48-48v-64.5l-45.59-45.6c-18.7428-18.7-18.7428-49.1 0-67.8l45.59-45.6v-64.5c0-26.51 21.49-48 48-48h64.5l45.6-45.59c18.7-18.7409 49.1-18.7409 67.8 0z";

const SEAL_OUTLINE_WIDTH = 10;
const SEAL_SHADOW_STEP_STROKE_WIDTH = 2;
const SHADOW_COLOR = "black";
const SHADOW_OPACITY = 0.15;

import styles from "./class-complete-seal.css";

@customElement("bp-class-complete-seal")
export class ClassCompleteSeal extends LitElement {
  static styles = styles;

  @property({ attribute: "artwork-src" })
  artworkSrc = "";

  private readonly clipPathId = `clip-${crypto.randomUUID()}`;
  private readonly inverseClipPathId = `inverse-clip-${crypto.randomUUID()}`;
  private readonly shapeId = `shape-${crypto.randomUUID()}`;

  render() {
    const clipUrl = `url(#${this.clipPathId})`;
    const inverseClipUrl = `url(#${this.inverseClipPathId})`;
    const shapeUrl = `#${this.shapeId}`;

    return html`
      <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <path id=${this.shapeId} d=${SEAL_CLIP_PATH} />
          <clipPath id=${this.clipPathId}>
            <use href=${shapeUrl} />
          </clipPath>
          <clipPath
            id=${this.inverseClipPathId}
            clipPathUnits="userSpaceOnUse"
            clip-rule="evenodd"
          >
            <path d="M0 0 H512 V512 H0 Z" />
            <path d=${SEAL_CLIP_PATH} />
          </clipPath>
        </defs>
        <image
          width="512"
          height="512"
          href=${this.artworkSrc}
          clip-path=${clipUrl}
        />
        <g clip-path=${inverseClipUrl}>
          <use
            href=${shapeUrl}
            fill="none"
            stroke=${SHADOW_COLOR}
            stroke-opacity=${SHADOW_OPACITY}
            stroke-width=${SEAL_SHADOW_STEP_STROKE_WIDTH}
          />
          <use
            href=${shapeUrl}
            fill="none"
            stroke=${SHADOW_COLOR}
            stroke-opacity=${SHADOW_OPACITY}
            stroke-width=${2 * SEAL_SHADOW_STEP_STROKE_WIDTH}
          />
          <use
            href=${shapeUrl}
            fill="none"
            stroke=${SHADOW_COLOR}
            stroke-opacity=${SHADOW_OPACITY}
            stroke-width=${3 * SEAL_SHADOW_STEP_STROKE_WIDTH}
          />
          <use
            href=${shapeUrl}
            fill="none"
            stroke=${SHADOW_COLOR}
            stroke-opacity=${SHADOW_OPACITY}
            stroke-width=${4 * SEAL_SHADOW_STEP_STROKE_WIDTH}
          />
        </g>
        <g clip-path=${clipUrl}>
          <use
            class="outline"
            href=${shapeUrl}
            fill="none"
            stroke="#fff"
            stroke-opacity="0.8"
            stroke-width=${SEAL_OUTLINE_WIDTH * 2}
          />
        </g>
      </svg>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-class-complete-seal": ClassCompleteSeal;
  }
}
